import { convert, LocalDate, Temporal } from '@js-joda/core'
import TemporalConverterBase from '@migrate/utils/date/TemporalConverterBase'
import NativeDateConverter from '@migrate/utils/date/NativeDateConverter'

export default class LocalDateConverter extends TemporalConverterBase {
  localizationOptions: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  }

  private readonly value: LocalDate

  constructor(value: LocalDate) {
    super()
    this.value = value
  }

  public getValue(): Temporal {
    return this.value
  }

  public toNative(): Date {
    return convert(this.value).toDate()
  }

  public toUsDateString() {
    return new NativeDateConverter(this.toNative()).toUsDateString()
  }
}
